import { Checkbox } from '@/shadcn/checkbox';

import { useSelectableItemsContext } from '..';

export const SelectableItemWrapper = ({
  children
}: React.PropsWithChildren) => {
  const { selected, handleChangeCheck } = useSelectableItemsContext();

  return (
    <div className="flex items-center gap-4">
      <Checkbox checked={selected} onCheckedChange={handleChangeCheck} />
      <div className="flex-1">{children}</div>
    </div>
  );
};
